import(/* webpackMode: "eager" */ "/app/src/app/(layout)/error.tsx");
